import {Component} from '@angular/core';
import {kanUsersService} from "../../../../services/services/users";
import {User} from "../../../../../classes/user";
import {MatDialog} from "@angular/material";
import {Dog} from "../../../../../classes/dog";

@Component({
    selector: 'kan-dog',
    templateUrl: './component.html',
    styleUrls: ['./component.scss']
})
export class kanDog {
    private owner: User;
    private dog: Dog
    public mode: string = 'edit';
    public text: string = 'testing text input';

    constructor(private dialog: MatDialog, private userService: kanUsersService) {
    }

    ngOnInit(): void {
        this.getUser();
    }

    private getUser(): void {
        // this.userService.getUsers()
        //   .then((users) => {
        //     this.users = users;
        //     this.filter();
        //   })
        //   .catch((error) => {
        //     console.log(error);
        //   });
    }

    public switchMode(): void {
        this.mode = this.mode === 'display' ? 'edit' : 'display';
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/dog/dog/component.ts